import type { IFetchService } from "app/services/fetchService";

import { SALES_WIDGET_ENDPOINT, ANALYSIS_ENDPOINT, API_ANALYSIS_ENDPOINT } from "../../../types";
import type { TAdNetworksAbout } from "../types/adNetwork";
import type { Feed, FeedRequestParams } from "../types/feed";
import type { SiteInfo } from "../types/siteInfo";
import type { TTopCountries } from "../types/topCountries";

export const createFeedApiService = (fetchService: IFetchService) => {
    return {
        /**
         * Fetches feed items for given domain
         * @param params
         */
        fetchWebsiteFeed(params: FeedRequestParams): Promise<Feed[]> {
            return fetchService.get(`${API_ANALYSIS_ENDPOINT}/news`, params);
        },
        fetchTopCountries(domain: string): Promise<TTopCountries> {
            return fetchService.get(
                `${ANALYSIS_ENDPOINT}/widget/top-countries-by-growth-and-share/table?domain=${domain}`,
            );
        },
        fetchAdNetworks(domain: string, country: string | number): Promise<TAdNetworksAbout> {
            return fetchService.get(`${API_ANALYSIS_ENDPOINT}/ad-networks?domain=${domain}&country=${country}`);
        },
        fetchSiteInfo(domain: string, country: number | string): Promise<SiteInfo> {
            return fetchService.get(`${ANALYSIS_ENDPOINT}/widget/single-metric?domain=${domain}&country=${country}`);
        },
        /**
         * Marks given feed items as "seen"
         * @param payload
         */
        setFeedItemsSeen(
            payload: FeedRequestParams & {
                feedItemsIds: string[];
                opportunityListId?: string;
                workspaceId: string;
            },
        ): Promise<unknown> {
            const { workspaceId, domain, feedItemsIds, opportunityListId } = payload;

            return fetchService.post(
                `${SALES_WIDGET_ENDPOINT}/seen-items-feed` +
                    `?workspaceId=${workspaceId}&opportunityListId=${opportunityListId}&domain=${domain}`,
                { feedItemsIds },
            );
        },
    };
};
